// source: src/common/setting/notification/notification.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_setting_notification_email_pb = require('../../../../src/common/setting/notification/email_pb.js');
goog.object.extend(proto, src_common_setting_notification_email_pb);
var src_common_setting_notification_slack_pb = require('../../../../src/common/setting/notification/slack_pb.js');
goog.object.extend(proto, src_common_setting_notification_slack_pb);
goog.exportSymbol('proto.loupe.common.setting.notification.Notification', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.setting.notification.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.setting.notification.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.setting.notification.Notification.displayName = 'proto.loupe.common.setting.notification.Notification';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.setting.notification.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.setting.notification.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.setting.notification.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.notification.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = msg.getEmail()) && src_common_setting_notification_email_pb.Email.toObject(includeInstance, f),
    slack: (f = msg.getSlack()) && src_common_setting_notification_slack_pb.Slack.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.setting.notification.Notification}
 */
proto.loupe.common.setting.notification.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.setting.notification.Notification;
  return proto.loupe.common.setting.notification.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.setting.notification.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.setting.notification.Notification}
 */
proto.loupe.common.setting.notification.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new src_common_setting_notification_email_pb.Email;
      reader.readMessage(value,src_common_setting_notification_email_pb.Email.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 2:
      var value = new src_common_setting_notification_slack_pb.Slack;
      reader.readMessage(value,src_common_setting_notification_slack_pb.Slack.deserializeBinaryFromReader);
      msg.setSlack(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.setting.notification.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.setting.notification.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.setting.notification.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.notification.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      src_common_setting_notification_email_pb.Email.serializeBinaryToWriter
    );
  }
  f = message.getSlack();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      src_common_setting_notification_slack_pb.Slack.serializeBinaryToWriter
    );
  }
};


/**
 * optional Email email = 1;
 * @return {?proto.loupe.common.setting.notification.Email}
 */
proto.loupe.common.setting.notification.Notification.prototype.getEmail = function() {
  return /** @type{?proto.loupe.common.setting.notification.Email} */ (
    jspb.Message.getWrapperField(this, src_common_setting_notification_email_pb.Email, 1));
};


/**
 * @param {?proto.loupe.common.setting.notification.Email|undefined} value
 * @return {!proto.loupe.common.setting.notification.Notification} returns this
*/
proto.loupe.common.setting.notification.Notification.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.setting.notification.Notification} returns this
 */
proto.loupe.common.setting.notification.Notification.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.setting.notification.Notification.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Slack slack = 2;
 * @return {?proto.loupe.common.setting.notification.Slack}
 */
proto.loupe.common.setting.notification.Notification.prototype.getSlack = function() {
  return /** @type{?proto.loupe.common.setting.notification.Slack} */ (
    jspb.Message.getWrapperField(this, src_common_setting_notification_slack_pb.Slack, 2));
};


/**
 * @param {?proto.loupe.common.setting.notification.Slack|undefined} value
 * @return {!proto.loupe.common.setting.notification.Notification} returns this
*/
proto.loupe.common.setting.notification.Notification.prototype.setSlack = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.setting.notification.Notification} returns this
 */
proto.loupe.common.setting.notification.Notification.prototype.clearSlack = function() {
  return this.setSlack(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.setting.notification.Notification.prototype.hasSlack = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.loupe.common.setting.notification);
